module.exports = __webpack_public_path__ + "static/media/video_2.f64659ab.mp4";